module.exports = __webpack_public_path__ + "12a5ad807292a25d0f66dd2be34bd0e8.svg";